<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id?'编辑课程类型':'新建课程类型'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="120px"
      >
        <el-form-item
          label="课程类型名称"
          prop="categoryName"
        >
          <el-input v-model="createForm.categoryName" />
        </el-form-item>
        <el-form-item
          label="小程序课程缩写"
          prop="mpIconName"
        >
          <el-input v-model="createForm.mpIconName" />
        </el-form-item>
        <el-form-item
          label="ICON显示图片(尺寸128*128)"
          prop="mpIconUrl"
        >
          <upload
            :file-list.sync="createForm.mpIconUrl"
            :auto-crop-width="128"
            :auto-crop-height="128"
          />
        </el-form-item>
        <el-form-item
          label="课程类型说明"
          prop="categoryDesc"
        >
          <el-input
            v-model="createForm.categoryDesc"
            type="textarea"
          />
        </el-form-item>
        <el-form-item
          label="排序值"
          prop="rank"
        >
          <el-input v-model="createForm.rank" />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'CourseCategoryDialog',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '新建课程类型',
      cancelText: '取消',
      createForm: {
        categoryName: null,
        categoryDesc: null,
        mpIconUrl: null,
        rank: null,
        id: null,
      },
      creatRules: {
        categoryName: [
          { required: true, message: '请输入课程类型名称', trigger: 'blur' },
        ],
        mpIconName: [
          { required: true, message: '请输入小程序课程缩写', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    item(val) {
      if (val) {
        const {
          categoryName,
          categoryDesc,
          rank,
          id,
          mpIconName,
          mpIconUrl,
        } = val;
        this.createForm = {
          categoryName,
          categoryDesc,
          rank,
          mpIconName,
          mpIconUrl,
          id,
        };
      }
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.course.upsertCategory(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改课程类型成功');
          } else {
            this.$message.success('新增课程类型成功');
          }

          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}
</style>
